<template>
  <div>
    <button class="btn btn-info m-2" @click="goBack">
      Back to all merchants
    </button>
    <card class="card" title="Add Merchant">
      <div>
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-4">
              <label>Select an Institution</label>
              <multiselect
                v-model="selectedInstitution"
                :custom-label="optionLabel"
                track-by="_id"
                :options="utils.institutions"
                :allow-empty="false"
                placeholder="Select an Institution"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  {{ option.institutionName }}
                </template>
              </multiselect>
            </div>

            <div class="col-md-4">
              <fg-input
                type="text"
                label="Merchant Name"
                placeholder="Merchant Name"
                v-model="merchant.merchantName"
              >
              </fg-input>
            </div>
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Business Name"
                placeholder="Business Name"
                v-model="merchant.companyName"
              >
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Address"
                placeholder="Business Address"
                v-model="merchant.address"
              >
              </fg-input>
            </div>

            <div class="col-md-4">
              <label>State</label>
              <select
                class="form-control op-border"
                id="rate-type"
                v-model="merchant.state"
                required
                @change="fetchLgas()"
              >
                <option value="">State</option>
                <option v-for="st in utils.allStates" :key="st" :value="st">
                  {{ st }}
                </option>
              </select>
            </div>

            <div class="col-md-4">
              <label>LGA</label>
              <select
                class="form-control op-border"
                id="rat-type"
                v-model="merchant.localGovernment"
                required
              >
                <option value="">Select Local Government</option>
                <option v-for="lg in utils.lgas" :key="lg.id" :value="lg.name">
                  {{ lg.name }}
                </option>
              </select>
              <span v-if="utils.lgaLoading"> Fetching Lga's </span>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <fg-input
                type="email"
                label="Email"
                placeholder="Email Address"
                v-model="merchant.email"
              >
              </fg-input>
            </div>

            <div class="col-md-4">
              <fg-input
                type="text"
                label="Phone Number"
                placeholder="Phone Number"
                v-model="merchant.phoneNumber"
                maxlength="11"
                @input="
                  merchant.phoneNumber = merchant.phoneNumber.replace(/\D/g, '')
                "
              >
              </fg-input>
            </div>

            <div class="col-md-4">
              <label>Sales Officer</label>

              <v-select
                v-model="merchant.salesOfficerId"
                :options="formattedSalesOfficers"
                :reduce="(officer) => officer._id"
                label="fullName"
                placeholder="Select Sales Officer"
                searchable
                style="border: none"
                required
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <fg-input
                type="password"
                label="Password"
                placeholder="Password"
                v-model="merchant.password"
              ></fg-input>
            </div>

            <div class="col-md-4">
              <fg-input
                type="password"
                label="Password Confirmation"
                placeholder="Password Confirmation"
                v-model="merchant.password_confirmation"
              ></fg-input>
            </div>
          </div>

          <div class="text-center">
            <p-button type="info" round @click.native.prevent="submit">
              <div
                class="spinner-grow"
                role="status"
                v-if="loading.show === true"
              ></div>
              Add Merchant
            </p-button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "../store/axios";
import Multiselect from "vue-multiselect";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    Multiselect,
    vSelect,
  },
  data() {
    return {
      merchant: {
        merchantName: "",
        companyName: "",
        email: "",
        address: "",
        phoneNumber: "",
        salesOfficerId: null,
      },
      selectedInstitution: "",
      allSalesOfficers: [],
    };
  },
  computed: {
    ...mapState(["auth", "loading", "utils"]),

    formattedSalesOfficers() {
      return this.allSalesOfficers.map((o) => ({
        ...o,
        fullName: `${o.firstName} ${o.lastName || ""}`.trim(),
      }));
    },
  },
  methods: {
    ...mapActions([
      "createPtspMerchant",
      "getStates",
      "getLgas",
      "getCountries",
      "getInstitutions",
    ]),
    goBack() {
      window.history.back();
    },

    isValid(values) {
      let missingFields = [];
      if (!values.selectedInstitution) {
        missingFields.push("Institution");
      }
      if (!values.merchantName) {
        missingFields.push("Merchant Name");
      }
      if (!values.companyName) {
        missingFields.push("Business Name");
      }
      if (!values.address) {
        missingFields.push("Address");
      }
      if (!values.email) {
        missingFields.push("Email");
      }
      if (!values.phoneNumber) {
        missingFields.push("Phone Number");
      }
      if (!values.password) {
        missingFields.push("Password");
      }
      if (!values.password_confirmation) {
        missingFields.push("Password Confirmation");
      }

      if (!values.state) {
        missingFields.push("State");
      }
      if (!values.localGovernment) {
        missingFields.push("Local Government");
      }

      if (missingFields.length > 0) {
        this.$toast.error(
          `Please fill in all the following fields: ${missingFields.join(
            ", ",
          )}`,
        );
        return false;
      }

      return true;
    },

    submit() {
      this.merchant.selectedInstitution = this.selectedInstitution;
      if (!this.isValid(this.merchant)) return;

      const payload = {
        ...this.merchant,
        institutionId: this.selectedInstitution._id || "",
      };

      delete payload.selectedInstitution;

      this.createPtspMerchant(payload);
    },
    fetchLgas() {
      this.merchant.lga = "";
      this.getLgas(this.merchant.state);
    },
    optionLabel({ institutionName }) {
      return `${institutionName}`;
    },

    async getSalesOfficers() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/external-request/user/get-all-users`,
        );
        this.allSalesOfficers = res.data.users;
        console.log(this.allSalesOfficers);
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Sales Officers",
          });
        }
        console.log("error", err);
      }
    },
  },
  mounted() {
    this.getInstitutions();
    this.getCountries();
    this.getStates();
    this.getSalesOfficers();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
